import { CHANNELS } from '../types';

export const HISTORY_TYPE_OPTIONS = [
    { value: CHANNELS.APP, label: 'Histórico APP' },
    { value: CHANNELS.CHAT, label: 'Histórico CHAT' },
    { value: CHANNELS.CHATBOT, label: 'Histórico CHATBOT' },
    { value: CHANNELS.TELEFONIA, label: 'Histórico TELEFONÍA' },
    { value: 'PQR', label: 'Histórico PQR' },
] as const;
